import Layout from '@layout/Index'

export const paymentCenter = [
  {
    path: '/payment-center',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "payment-center-table" */ './pages/PaymentCenterTable.vue'),
        meta: {
          title: '支付中心',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "payment-center-detail" */ '@views/payment-manager-new/pages/PaymentManagerReview.vue'),
        meta: {
          isApproval: true,
          showConfirmAmount: true,
          title: '支付中心详情',
        },
      },
      {
        // 退款: 直接复用付款审批的详情页
        path: 'refund/:id',
        component: () => import(/* webpackChunkName: "payment-center-refund" */ './pages/PaymentCenterReview.vue'),
        meta: {
          isRefund: true,
          isReview: true,
          isApproval: true,
          title: '退款',
        },
      },
      {
        // 付款信息回填
        path: 'upload-receipt/:id',
        component: () => import(/* webpackChunkName: "payment-center-uplaod-receipt" */ './pages/PaymentCenterReview.vue'),
        meta: {
          isReview: true,
          isApproval: true,
          title: '付款信息回填',
        },
      },
    ],
  },
]





// WEBPACK FOOTER //
// ./src/views/payment-center/payment-center.route.js